<template>
  <div class="modal animated fadeIn">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">{{ $t('new_proposal_modal.new_proposal') }}</p>
      </header>
      <section class="modal-card-body">
        <form>


          <div class="float-label full remove-padding-right">
            <input v-validate="'required'" type="text" name="document-name" id="document-name" v-model="document.title" required>
            <label for="document-name">{{ $t('new_proposal_modal.proposal_name') }}</label>
            <span class="help-block" v-show="errors.has('document-name')">{{ errors.first('document-name') }}</span>
          </div>

          <h3 v-if="!$route.query.copy_document_id">{{ $t('new_proposal_modal.where_to_start') }}</h3>
          <div class="where-to-start" v-if="!$route.query.copy_document_id">
            <multiselect
              v-model="selectedDocumentOrigin"
              :options="documentOriginOptions"
              :placeholder="$t('new_proposal_modal.template_select_dropdown.select_one')"
              :searchable="false"
              :showLabels="false"></multiselect>
            <multiselect
              v-if="selectedDocumentOrigin === 'Template'"
              v-model="selectedTemplate"
              :options="templates"
              :placeholder="$t('new_proposal_modal.template_select_dropdown.select_one')"
              track-by="id"
              label="title"
              :searchable="true"
              :showLabels="false"
              :maxHeight="150"
            ></multiselect>
            <multiselect
              v-if="selectedDocumentOrigin === 'Recent Document'"
              v-model="selectedDocument"
              :options="recentDocuments"
              :placeholder="$t('new_proposal_modal.template_select_dropdown.select_one')"
              track-by="id"
              label="title"
              :searchable="true"
              :showLabels="false"
              :maxHeight="150"
            ></multiselect>
          </div>
        </form>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary is-large" @click="createDocument()" :disabled="!document.title">{{ $t('new_proposal_modal.create_proposal') }}</a>
      </footer>
    </div>
  </div>
</template>

<script>
  import API from 'mixins/api';

  export default {
    mixins: [API],
    props: ['options'],
    data() {
      return {
        Events: window.Events,
        selectedTemplate: null,
        selectedContact: null,
        selectedDocument: null,
        selectedDocumentOrigin: null,
        documentOriginOptions: [
          'Blank Document',
          'Recent Document',
          'Template',
        ],
        contacts: [],
        document: {
          contacts: [],
          contact_id: null,
          title: '',
          template_id: null,
          copy_document_id: null
        },
        templates: [],
        recentDocuments: []
      }
    },
    beforeMount() {
      this.api().fetchTeamTemplates().then(templates => this.templates = templates);
      this.api().fetchTeamContacts().then(contacts => this.contacts = contacts);
      this.Events.$on('createContact', (contact) => {
        this.document.contacts.push(contact);
      });
    },
    mounted() {
      // Sync contact list
      this.Events.$on('contactsChange', () => {
        this.fetchTeamContacts().then(contacts => this.contacts = contacts);
      });

      // Get recent documents
      if (this.$route.query && this.$route.query.copy_document_id) {
        this.document.copy_document_id = Number(this.$route.query.copy_document_id);
      } else {
        this.api().fetchRecentDocuments()
          .then(recentDocuments => this.recentDocuments = recentDocuments);
      }

      if (this.options && this.options.contact) {
        this.document.contacts.push(this.options.contact);
      }
    },
    methods: {
      closeModal() {
        this.Events.$emit('modalClose', 'newDocumentModal');
        this.clearForm();
      },
      clearForm() {
        this.document = {
          contacts: [],
          title: '',
          template_id: null,
          copy_document_id: null
        };
      },
      createDocument() {
        // Save new Document, get back ID
        this.api().createDocument(this.document)
          .then(document => {
            this.closeModal();
            this.$router.push('/a/document/' + document.id);
            this.clearForm();
          });
      }
    },
    watch: {
      selectedDocumentOrigin() {
        this.selectedTemplate = null;
        this.selectedDocument = null;
        this.document.template_id = null;
        this.document.copy_document_id = null;
      },
      selectedTemplate() {
        if (this.selectedTemplate !== null) {
          this.document.template_id = this.selectedTemplate.id;
          this.selectedDocument = null;
          this.document.copy_document_id = null;
        }
      },
      selectedDocument() {
        if (this.selectedDocument !== null) {
          this.document.copy_document_id = this.selectedDocument.id;
          this.selectedTemplate = null;
          this.document.template_id = null;
        }
      },
      options() {
        if (this.options && this.options.contact) {
          this.document.contacts.push(this.options.contact);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }
  .modal-background {
    background: hsla(0,0%,100%,.3);
  }
  .modal {
    .modal-card {
      max-width: 360px;
      .modal-card-head {
        padding-bottom: 20px;
      }
      .modal-card-body {
        overflow: visible;
        form {
          h3 {
            font-size: 13px;
            letter-spacing: 0.7px;
            margin: 20px 0 10px;
          }
        }
      }
      .modal-card-foot {
        padding-top: 30px;
      }
      a {
        margin-bottom: 10px;
      }
    }
  }

  .label {
    padding-top: 20px;
    font-weight: 500;
    .selected-contact {
      border-bottom: 1px solid $mutedblue;
      padding-bottom: 6px;
    }
    label {
      width: 100%;
      a {
        float: right;
        margin-right: 10px;
        margin-top: -3px;
        span {
          font-size: 13px;
        }
      }
    }
  }
  select {
    display: block;
    padding: 2px 40px 2px 4px;
    border-radius: 2px;
    border: 1px solid lighten($mutedblue, 12%);
    background: $white;
    color: #54555E;
    margin-bottom: 10px;
    height: 32px;
    width: 100%;
    -webkit-appearance: none;
    font-size: 13px;
    padding-left: 9px;
    &:hover {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// new-document-modal.vue?878774b6